"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilliGramHydrogenCarbonatePerLiter = void 0;
var uom_1 = require("uom");
// Alkalinity
exports.MilliGramHydrogenCarbonatePerLiter = uom_1.Unit.createBase("MilliGramHydrogenCarbonatePerLiter", "Alkalinity", "mg HCO₃⁻/l");
//# sourceMappingURL=alkalinity.js.map